// reactstrap components
import { Container } from "reactstrap";

const AuthFooter = () => {
  return (
    <footer className="py-5">
      <Container>
        <div className="copyright text-center text-muted">
          © {new Date().getFullYear()} AKH Dashboard
        </div>
      </Container>
    </footer>
  );
};

export default AuthFooter;
